"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFulfillmentConfigManagerLink = exports.formatDateUnits = exports.formatDateTime = void 0;
var _luxon = require("luxon");
var _envConstants = require("../constants/envConstants");
var DEFAULT_DATE_TIME_FORMAT = 'y-LL-dd HH:mm:ss ZZZZ';

// Default is local system time
var formatDateTime = exports.formatDateTime = function formatDateTime(date, timezone) {
  return _luxon.DateTime.fromISO(date).setZone(timezone || undefined).toFormat(DEFAULT_DATE_TIME_FORMAT);
};
var formatDateUnits = exports.formatDateUnits = function formatDateUnits(unit) {
  switch (unit) {
    case 'HH':
      return 'Hours';
    case 'DD':
      return 'Days';
    default:
      return '';
  }
};
var formatFulfillmentConfigManagerLink = exports.formatFulfillmentConfigManagerLink = function formatFulfillmentConfigManagerLink(fulfillmentConfigurationId, env) {
  if (!fulfillmentConfigurationId) {
    return '';
  }
  return "https://".concat(env === _envConstants.INT ? 'int.' : '', "fulfillmentconfigurations.cimpress.io/fulfillmentconfiguration/").concat(fulfillmentConfigurationId);
};